import { useTranslation } from 'react-i18next';
import { LockClosedIcon } from '@heroicons/react/24/outline';

export const ReadOnlyIndicator = () => {
  const { t } = useTranslation();

  return (
    <div className="flex items-center gap-1 text-xs text-gray-400">
      <LockClosedIcon className="size-3.5" />
      {t('settings:documentUnderstandingAgent.global.readOnly')}
    </div>
  );
};
